import useGetAvailableWebhookEvents from '@/api/queries/useGetAvailableWebhookEvents';
import {
  Button,
  CardButton,
  Input,
  InputIcon,
  Sidebar,
  SidebarProps as TSidebarProps,
} from '@payaca/ambrosia';
import List from '@payaca/components/list/List';

import { FC, useEffect, useState } from 'react';

export type TProps = {
  subscribedEvents: string[];
  onChange: (subscribedEvents: string[]) => void;
} & Omit<TSidebarProps, 'title'>;

const SubscribeToEventsSidebar: FC<TProps> = (props) => {
  const { subscribedEvents, onChange, isOpen, onClose, ...rest } = props;

  /**
   * state
   */
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    if (isOpen) {
      setSearchQuery('');
    }
  }, [isOpen]);

  /**
   * queries
   */
  const { data: availableWebhookEvents } = useGetAvailableWebhookEvents();

  const handleChange = (eventName: string) => () => {
    const isSubscribed = subscribedEvents.includes(eventName);
    const newSubscribedEvents = isSubscribed
      ? subscribedEvents.filter((name) => name !== eventName)
      : [...subscribedEvents, eventName];

    onChange(newSubscribedEvents);
  };

  const filteredEvents = (
    availableWebhookEvents?.availableWebhookEvents || []
  ).filter(
    (event) =>
      event.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      event.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Sidebar
      isOpen={isOpen}
      title="Subscribe to Event"
      onClose={onClose}
      {...rest}
    >
      <Sidebar.Body className="p-4">
        <List
          prefix={
            <Input
              data-autofocus
              type="search"
              aria-label={`Search`}
              leadingElement={<InputIcon name="search-lg.3" />}
              sizeVariant="sm"
              placeholder="Search"
              value={searchQuery}
              onChange={setSearchQuery}
            />
          }
          items={filteredEvents}
          item={(event) => {
            const isDisabled = subscribedEvents?.includes(event.name);

            return (
              <CardButton
                disabled={isDisabled}
                onClick={handleChange(event.name)}
              >
                <CardButton.Body>
                  <h4>{event.name}</h4>

                  <p>{event.description}</p>
                </CardButton.Body>
              </CardButton>
            );
          }}
        />
      </Sidebar.Body>

      <Sidebar.Footer>
        <Button className="w-full" onClick={onClose}>
          Done
        </Button>
      </Sidebar.Footer>
    </Sidebar>
  );
};

export default SubscribeToEventsSidebar;
